<script setup>
import { ref } from 'vue';
import { notification } from 'ant-design-vue';
import BaseModalAdd from '@/components/base/BaseModalAdd.vue';
import { addRole } from '@/api/roles/addRole';

const props = defineProps({
    open: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['update:open', 'success']);

const loading = ref(false);

// 表單項目定義
const formItems = [
    {
        label: '角色名稱',
        key: 'name',
        placeholder: '請輸入角色名稱',
        rules: [
            { required: true, message: '請輸入角色名稱', trigger: 'blur' },
            {
                min: 2,
                max: 20,
                message: '姓名長度應在 2-20 個字元之間',
                trigger: 'blur'
            }
        ]
    }
];

// 處理表單提交
const handleSubmit = async (formData) => {
    loading.value = true;

    try {
        const response = await addRole(formData.name);

        if (response.status === 1) {
            notification.success({
                message: '新增成功',
                description: response.message || '角色新增成功'
            });
            emit('success', response.data);
            emit('update:open', false);
        } else {
            // 處理驗證錯誤
            if (response.errors) {
                const errorMessages = Object.values(response.errors)
                    .flat()
                    .join(', ');
                notification.error({
                    message: '新增失敗',
                    description: errorMessages
                });
            } else {
                notification.error({
                    message: '新增失敗',
                    description: response.message || '新增角色時發生錯誤'
                });
            }
        }
    } catch (error) {
        console.error('新增角色 API 錯誤:', error);

        // 處理 HTTP 422 錯誤
        if (error.response?.status === 422) {
            const errorData = error.response.data;
            if (errorData.errors) {
                const errorMessages = Object.values(errorData.errors)
                    .flat()
                    .join(', ');
                notification.error({
                    message: '驗證失敗',
                    description: errorMessages
                });
            } else {
                notification.error({
                    message: '新增失敗',
                    description: errorData.message || '資料驗證失敗'
                });
            }
        } else {
            notification.error({
                message: '新增失敗',
                description: '網路連線錯誤，請稍後再試'
            });
        }
    } finally {
        loading.value = false;
    }
};
</script>

<template>
    <BaseModalAdd
        :open="open"
        title="新增角色"
        :form-items="formItems"
        :loading="loading"
        @update:open="$emit('update:open', $event)"
        @submit="handleSubmit"
    />
</template>
